"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPathsGroupNode_1 = __importDefault(require("./isPathsGroupNode"));
const getNodeType = (node) => {
    if (isPathsGroupNode_1.default(node)) {
        return 'paths_group';
    }
    return node.type_of;
};
exports.default = getNodeType;
